export default __webpack_public_path__ + "static/table-9848bb9645c6fa82f59f59e00b906b96.png";